import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutColumn: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconLayoutColumn"><Path d="M3 21V3H11V21L3 21Z" fill="currentColor"/><Path d="M13 21L21 21V3H13V21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutColumn;
